export const TOWER_ALERT_REVIEW_LOAD = "TOWER_ALERT_REVIEW_LOAD";
export const TOWER_ALERT_REVIEW_UPDATE = "TOWER_ALERT_REVIEW_UPDATE";
export const TOWER_POSTOPREVIEW_DATA = "TOWER_POSTOPREVIEW_DATA";
export const TOWER_POSTOPREVIEW_SAVE = "TOWER_POSTOPREVIEW_SAVE";
export const TOWER_REVIEW_DATA = "TOWER_REVIEW_DATA";
export const TOWER_REVIEW_SAVE = "TOWER_REVIEW_SAVE";
